import { useState } from 'react';
import AllergensButton from './AllergensButton';
import AllergensList from './AllergensList';

const useAllergens = () => {
  const [isAllergensOpened, setIsAllergensOpened] = useState(false);

  const toggleAllergens = () => setIsAllergensOpened(!isAllergensOpened);

  return {
    AllergensButton,
    AllergensList,
    isAllergensOpened,
    toggleAllergens,
  };
};

export default useAllergens;
